<template>
    <div id="page-user-list" class="flex flex-col flex-wrap w-full">
        <div class="w-full p-6">
          <h1> Mis clientes </h1>
        </div>

        <div class="w-full p-6">
            <div class="grid grid-cols-5">
                <div>Nombres</div>
                <div>Contacto</div>
                <div>Nacionalidad</div>
                <div>Servicios</div>
                <div>Ultimo Paso</div>
            </div>
        </div>

        <div class="vx-card p-6 mb-4 relative" v-for="i in clients" :key="i.id">
            <div class="grid grid-cols-5 items-center pr-8">
                <div>
                    {{i.names_client}} {{i.surnames_client}}
                </div>
                <div>
                    <a v-if="i.phone_mobile_client" target="_blank" :href="'https://wa.me/' + i.phone_mobile_client.replaceAll(/\s/g,'')">
                        <vs-chip  class="vs-chip">
                            <feather-icon icon="PhoneIcon" class="mr-2" svgClasses="stroke-current" />
                            <span>WhatsApp</span>
                        </vs-chip>
                    </a>

                    <a v-if="i.phone_office_client" target="_blank" :href="'tel:' + i.phone_office_client">
                        <vs-chip  class="vs-chip">
                            <feather-icon icon="BriefcaseIcon" class="mr-2" svgClasses="stroke-current" />
                            <span>Telefono - Oficina</span>
                        </vs-chip>
                    </a>
                    <a v-if="i.landline_client" target="_blank" :href="'tel:' + i.landline_client">
                        <vs-chip  class="vs-chip">
                            <feather-icon icon="HomeIcon" class="mr-2" svgClasses="stroke-current" />
                            <span>Telefono - Casa</span>
                        </vs-chip>
                    </a>

                    <a v-if="i.email_user" target="_blank" :href="'mailto:' + i.email_user">
                        <vs-chip  class="vs-chip">
                            <feather-icon icon="MailIcon" class="mr-2" svgClasses="stroke-current" />
                            <span>Email</span>
                        </vs-chip>
                    </a>
                </div>
                <div>
                    <vs-chip v-if="i.name_first_nationality" class="vs-chip">
                        {{ i.name_first_nationality }}
                    </vs-chip>
                    <vs-chip v-if="i.name_second_nationality" class="vs-chip">
                        {{ i.name_second_nationality }}
                    </vs-chip>
                </div>
                <div>
                  <vs-chip class="vs-chip text-center" v-for="role in i.addedServices" :key="role.id_role">
                    {{ role.name_visa_type }}
                  </vs-chip>
                </div>
                <div>
                  <div class="w-full pb-2 px-4 text-center text-sm text-grey">
                    {{ i.completedSteps }} / {{ i.visaSteps.length }}
                  </div>
                  <vs-chip class="vs-chip text-center" v-if="i.visaSteps && i.visaSteps.length">
                    {{ i.visaSteps[0].name_visa_step }} - 
                    {{ i.visaSteps[0].number_advisor_visa_step }} - 
                    {{ i.visaSteps[0].advisor_description_visa_step }}
                  </vs-chip>
                </div>
            </div>
            <div class="absolute" style="top: 50%; right: 0.5rem; transform: translateY(-50%);">
                <vs-button class="p-2" type="flat" size="small" @click="$router.push('/admin/cliente/' + i.id_client)">
                    <feather-icon icon="MoreVerticalIcon" svgClasses="stroke-current" />
                </vs-button>
            </div>
        </div>
    </div>
</template>
<script>
//import axios from '@/axios.js'
export default {
  data () {
    return { 
      clients: []
    }
  },
  methods: {
  },
  async mounted () {
    await this.$store.dispatch('fetchClientsPDN').catch(err => { 
      console.error(err)
      this.$vs.notify({
        title: 'Error',
        text:  `${err.response.data.error}`,
        color: 'danger',
        iconPack: 'feather',
        icon:'icon-alert-circle',
        time:6000
      })
    })
    await this.$store.dispatch('fetchClientsAddedServices').catch(err => { 
      console.error(err)
      this.$vs.notify({
        title: 'Error',
        text:  `${err.response.data.error}`,
        color: 'danger',
        iconPack: 'feather',
        icon:'icon-alert-circle',
        time:6000
      })
    })
    await this.$store.dispatch('fetchVisaStepsForAClient').catch(err => { 
      console.error(err)
      this.$vs.notify({
        title: 'Error',
        text:  `${err.response.data.error}`,
        color: 'danger',
        iconPack: 'feather',
        icon:'icon-alert-circle',
        time:6000
      })
    })
    
    
    if (this.$store.state.countries.length === 0) {
      this.$store.dispatch('fetchCountries').catch(err => { console.error(err) })
    }
    if (this.$store.state.employees.length === 0) {
      this.$store.dispatch('fetchEmployees').catch(err => { console.error(err) })
    }

    ////    ////    ////    ////    ////    ////    ////    ////

    const advisor = this.$store.state.user
    if (advisor && advisor.employee_id) {
      const clientsData = this.$store.state.clientsPDN.filter(i => {
        return i.assignedAdvisor && i.assignedAdvisor.id_employee === advisor.employee_id
      })
      clientsData.forEach(client => {
        const services = []
        this.$store.state.clientsAddedServices.forEach(service => {
          if (service.id_client === client.id_client && service.flag_active_plan_added_service) services.push(service)
        })
        client.addedServices = services

        const visaSteps = []
        let completedSteps = 0
        this.$store.state.visaStepsForAClient.forEach(service => {
          if (service.id_client === client.id_client && service.status_visa_step === 'Sin Iniciar') visaSteps.push(service)
          if (service.id_client === client.id_client && service.status_visa_step === 'Completado') completedSteps++
        })
        client.visaSteps = visaSteps.sort((a, b) => a.number_client_visa_step - b.number_client_visa_step)
        client.completedSteps = completedSteps
      })

      this.clients = clientsData.sort((a, b) => b.id_client - a.id_client)
    }
  }
}
</script>